import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import NewsCard from "./NewsCard";

const MainNewsSection = ({ newsData }) => {
  // اگر دیتا هنوز نرسیده بود یا خالی بود، چیزی نشان نده یا یک لودینگ کوچک
  if (!newsData || newsData.length === 0) return null;

  return (
    <div className=" w-full min-w-0">
      <div className="flex justify-center items-center mb-3 lg:mb-4 sm:px-2 max-sm:ml-5">
        <h3 className="flex items-center gap-4 w-full font-semibold text-[#383838]">
          <span className="flex-1 h-[2px] rounded-full bg-gradient-to-r from-purple/10 to-transparent"></span>
          <span className="flex items-center whitespace-nowrap px-2 text-[17px] md:text-[23px]">
            <span className="text-[#383838]">جدیدترین</span>
            <span className="text-[#383838] mx-1.5">مقالات</span>
          </span>
          <span className="flex-1 h-[2px] rounded-full bg-gradient-to-l from-purple/10 to-transparent"></span>
        </h3>
      </div>

      <Swiper
        spaceBetween={16}
        slidesPerView={1.2} // نمایش 1 کارت کامل و بخشی از کارت دوم در موبایل
        breakpoints={{
          480: { slidesPerView: 1.5 },
          640: { slidesPerView: 2.2 },
          768: { slidesPerView: 3 },
          900: { slidesPerView: 4 },

          1200: { slidesPerView: 5 },
        }}
        className="w-full pb-4"
      >
        {newsData.map((item, index) => (
          <SwiperSlide key={item.id} className="!h-auto">
            <NewsCard
              img={item.thumb} // فیلد عکس در بک‌بند thumb است
              date={item.time} // فیلد زمان time است
              name={item.authur} // فیلد نویسنده authur است
              title={item.title}
              url={item.url} // اگر در کارت نیاز به لینک دارید
              // شرط‌ها و استایل‌های شما کاملا حفظ شد
              className={
                index === 0
                  ? "col-span-2 sm:col-span-1 lg:col-span-2 lg:row-span-2"
                  : ""
              }
              height={
                index === 0
                  ? "max-h-[150px] lg:max-h-max"
                  : "min-h-[100px] lg:h-[150px]"
              }
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default MainNewsSection;
